import React from 'react';
import {useTranslation} from '../../../config/TranslationProvider';

const FulltextInput = ({register, selected = '', id = 'fulltextSearch', ariaLabel = null}) => {
    const defaultAriaLabel = useTranslation('fulltext_search');
    return (
        <>
            <input
                type="text"
                name="fulltext"
                id={id}
                className="form-control"
                ref={register}
                defaultValue={selected}
                placeholder={useTranslation('search_placeholder')}
                aria-label={ariaLabel ? ariaLabel : defaultAriaLabel}
            />
        </>
    );
};

export default FulltextInput;
